<script setup lang="ts">
/**
 * Status pill.
 *
 * Tones map to meaning, never to decoration: `danger` is reserved for things that
 * are actually wrong, so a register full of amber does not train people to ignore
 * red. Colour is paired with the label text, never the sole carrier of meaning.
 */
const props = withDefaults(
  defineProps<{ tone?: 'neutral' | 'info' | 'good' | 'warn' | 'danger'; subtle?: boolean }>(),
  { tone: 'neutral', subtle: false },
)

const tones: Record<string, string> = {
  neutral: 'bg-[var(--ax-color-muted)] text-[var(--ax-color-muted-foreground)] border-[var(--ax-color-border)]',
  info: 'bg-[var(--ax-color-primary)]/10 text-[var(--ax-color-primary)] border-[var(--ax-color-primary)]/25',
  good: 'bg-emerald-500/10 text-emerald-700 dark:text-emerald-400 border-emerald-500/25',
  warn: 'bg-amber-500/10 text-amber-700 dark:text-amber-400 border-amber-500/25',
  danger:
    'bg-[var(--ax-color-destructive)]/10 text-[var(--ax-color-destructive)] border-[var(--ax-color-destructive)]/25',
}
</script>

<template>
  <span
    class="inline-flex items-center gap-1 whitespace-nowrap rounded border px-1.5 py-0.5 text-xs font-medium leading-4"
    :class="[tones[props.tone], props.subtle ? 'opacity-80' : '']"
  >
    <slot />
  </span>
</template>
